import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
function AdminRejectedMeals() {
const [summary, setSummary] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
const fetchSummary = async () => {
try {
const token = await window.firebase.auth().currentUser.getIdToken();
const res = await fetch(`${API_BASE_URL}/api/admin/rejected-meals-summary`, {
headers: { Authorization: `Bearer ${token}` },
});
const data = await res.json();
setSummary(data);
} catch (err) {
console.error("Failed to load rejected meals summary", err);
toast.error("Failed to fetch data");
} finally {
setLoading(false);
}
};
fetchSummary();
}, []);

if (loading) return <p>Loading rejected meals...</p>;

return (
<div className="p-6">
<h2 className="mb-4 text-2xl font-bold">🚫 Rejected Meals Summary</h2>
<div className="overflow-x-auto">
<table className="min-w-full text-sm border border-gray-200">
<thead className="bg-gray-100">
<tr>
<th className="px-4 py-2 border">Meal</th>
<th className="px-4 py-2 border">Rejections</th>
<th className="px-4 py-2 border">Reasons</th>
</tr>
</thead>
<tbody>
{summary.map((item) => (
<tr key={item.mealId} className="border-t hover:bg-gray-50">
<td className="px-4 py-2">{item.name}</td>
<td className="px-4 py-2 text-center">{item.count}</td>
<td className="px-4 py-2 space-y-1">
{item.reasons.map((r, idx) => (
<p key={idx}>
<strong>{r.reason}</strong>: {r.count}
</p>
))}
</td>
</tr>
))}
</tbody>
</table>
</div>
</div>
);
}

export default AdminRejectedMeals;